import Page from '../../../layout/Page/Page';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import { CommonCostCenterList } from './Common/CommonCostCenterList';

const CostCenterPage = () => {
	return (
		<PageWrapper title='Centros de custo'>
			<Page container='fluid'>
				<div className='row'>
					<div className='col-12'>
						<CommonCostCenterList />
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};

export default CostCenterPage;
